<template>
  <div>
    <viewTable
      ref="viewTable"
      :limits="limits"
      :columns-property="columnsProperty"
      :filter="filter"
      module="basic"
      url="units"
      :table-select="false"
      @addOrEdit="addEditHandle"
      @delete="deleteHandle"
      @reset="resetHandle"
    >
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="编号">
            <el-input v-model.trim="filter.unitNo" placeholder="请输入计量单位编号" clearable />
          </el-form-item>
          <el-form-item label="名称">
            <el-input v-model.trim="filter.unitName" placeholder="请输入计量单位名称" clearable />
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <UnitEdit ref="unitEdit" @save-success="loadData"></UnitEdit>
  </div>
</template>

<script>
import viewTable from "@/components/ViewTable.vue";
import UnitEdit from "./UnitEdit";
export default {
  components: { viewTable, UnitEdit },
  data() {
    return {
      limits: {
        addAuth: this.$auth(661),
        editAuth: this.$auth(662),
        delAuth: this.$auth(663),
      },
      filter: {
        unitNo: "",
        unitName: "",
      },
      columnsProperty: [
        {
          tooltip: true,
          key: "unitNo",
          width: 100,
          align: "center",
        },
        {
          tooltip: true,
          key: "unitName",
          minWidth: 150,
        },
        {
          tooltip: true,
          key: "creatorName",
          width: 100,
          align: "center",
        },
        {
          tooltip: true,
          key: "createTime",
          width: 160,
          align: "center",
        },
        {
          key: "action",
          align: "center",
          width: 140,
          slot: "action",
        },
      ],
    };
  },
  methods: {
    // 查询计量单位列表
    loadData(pageNum) {
      this.$refs.viewTable.loadData(pageNum);
    },

    // 新建 编辑
    addEditHandle(row) {
      this.$refs.unitEdit.open(row);
    },

    // 删除
    deleteHandle(row) {
      this.$http.delete("basic", "units", row.pkId).then((resp) => {
        if (resp.success) {
          this.$message.success("删除成功");
          this.loadData();
        }
      });
    },

    // 重置
    resetHandle(filter) {
      this.filter = Object.assign(this.filter, filter);
    },
  },
};
</script>
